import React from 'react'

const Toolbar = (props:any) => {
  return (
    <div className="hide-on-print">{props.children}</div>
  )
}

export default Toolbar